let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7Q0UC"), load("943D1")]).then(() => parcelRequire('ddp7n'));